import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const actions = createActions({
  ADMIN: {
    ADD_TASK_GROUP: (taskGroup) => ({ taskGroup }),
    API: {
      ADD_TASK_GROUP: apiResourceActionCreator('taskGroup')
    }
  }
})

export const apiAction = (authToken, payload) => commonApiActions.authenticated.post(`${API_ENDPOINT}/taskGroups`, authToken, payload.taskGroup, actions.admin.api.addTaskGroup);

function* addTaskGroup(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken, action.payload));
}

const configuration = {
  name: 'addTaskGroup',
  action: actions,
  sagas: addTaskGroup,
  reducers: {
    request: (state, action) => ({
      ...state,
      isUpdatingTaskGroup: true,
      error: null
    }),
    success: (state, action) => ({
      ...state,
      adminTaskGroup: action.payload.taskGroup,
      isUpdatingTaskGroup: false,
      error: null
    }),
    failed: (state, action) => ({
      ...state,
      isUpdatingTaskGroup: false,
      error: action.payload.error
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/admin/configurations/addTaskGroup.js